import { LoanSetupScreen } from "@/screens/loans/components/setup/LoanSetupScreen"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import LoanProductScroller from "@/screens/loans/components/LoanProductScroller"
import { Tiny } from "@/components/standard/BFText"
import { router } from "expo-router"

export const LoanSelectProductScreen = ({
  backButton,
}: {
  backButton?: () => void
}) => {
  const { loanApplication } = useLoanContext()

  async function doSubmit() {
    router.push("./submit")
  }

  return (
    <LoanSetupScreen
      title={"Select Loan Product"}
      subTitle={
        "The final product and terms can be discussed with your lending expert."
      }
      stepData={[3, 4]}
      nextButtonProps={{
        title: "Next: Review & Submit",
        disabled: loanApplication.loanProduct === undefined,
      }}
      onSubmit={doSubmit}
      backButton={backButton}
    >
      <LoanProductScroller />
      <Tiny className="px-6 py-2 text-midnight-blue">
        *Eligibility is based on self-reported information. Loan approval is
        subject to verification of qualifications. Terms and conditions apply.
      </Tiny>
    </LoanSetupScreen>
  )
}
